import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IVms } from '@obvious.tech/constellation'

export const Vms = defineEntity('Vms', {
  endpoint: 'videomanager/api/Vms',
  schema: SNoop<IVms>(),
})
